module.exports = {
  i18n: {
    locales: ['ro', 'en', 'hu', 'de', 'fr', 'it', 'es'],
    defaultLocale: 'ro',
    localeDetection: false,
  },
  trailingSlash: true,
};
